/* eslint-disable react/destructuring-assignment */

import { withStyles } from '@material-ui/core/styles'
import Settings from '@material-ui/icons/Settings'
/* eslint-disable react/jsx-key */
import cn from 'classnames'
import _ from 'lodash'
import React, { PureComponent } from 'react'
import styled from 'styled-components'

import shallowEqual from '../../utils/shallowEqual'
import ExportTableData from '../ExportTableData'
// import PagingSetting from '../../components/PagingSetting/PagingSetting';
// import Pagination from '../../components/Pagination/Pagination';
import IconButton from '../IconButton'
import Pagination from '../Pagination'
import PagingSetting from '../PagingSetting'
import TableSettingModal from '../TableSettingModal'
import TextInput from '../TextInput'
// import TableSettingModal from '../../components/TableSettingModal/TableSettingModal';
import { Text } from '../Typography'
import TableHeader from './TableHeader'
import TableRow from './TableRow'

const styles = () => ({
  noData: {
    height: 200,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomRow: {
    paddingTop: 10,
  },
  filter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 10,
    '& > div': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  'top-table': {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  'col-dropdown': {
    display: 'flex',
    justifyContent: 'space-between',
    '&.dropdown': {
      marginRight: '10px',
    },
  },
  'search-box': {
    display: 'flex',
    justifyContent: 'space-between',
  },
  'header-button': {
    display: 'flex',
    justifyContent: 'space-between',
  },
  'search-box-item': {
    maxWidth: 220,
    marginLeft: '10px',
    justifyContent: 'flex-start',
    border: '0px',
    '& input': {
      height: 'auto',
      fontSize: '14px',
      lineHeight: '16px',
      padding: '8px 34px 8px 10px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      '&:focus': {
        borderColor: '#009ade',
      },
    },
    '& .input-wrapper i': {
      padding: '0',
      marginRight: '6px',
    },
  },
  'table-config': {
    padding: '3px 0',
    marginLeft: '10px',
    width: '34px',
    height: '34px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  'paging-wrapper': {
    display: 'inherit',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  table: {
    width: '100%',
    maxWidth: '100%',
    marginBottom: '20px',
    // backgroundColor: 'white',
    color: '#4a4a4a',
    fontSize: '13px',
    fontWeight: 400,
    '& a': {
      color: '#009ade !important',
      transition: 'color 0.1s linear',
      textDecoration: 'none',
      '&:hover': {
        color: '#13174f !important',
        textDecoration: 'underline',
      },
    },
    '& label': {
      marginBottom: 0,
    },
  },
})

const TableWrap = styled.div`
  width: 100%;
  overflow-x: scroll;
  position: relative;

  background-image:
    linear-gradient(to right, white, white), linear-gradient(to right, white, white),
    linear-gradient(to right, rgba(30, 30, 30, 0.15), rgba(255, 255, 255, 0)),
    linear-gradient(to left, rgba(30, 30, 30, 0.15), rgba(255, 255, 255, 0));
  background-position:
    left center,
    right center,
    left 40px,
    right 40px;
  background-repeat: no-repeat;
  background-color: white;
  background-size:
    20px 100%,
    20px 100%,
    10px 100%,
    10px 100%;
  background-attachment: local, local, scroll, scroll;

  /* Craig: Work in progress, hover buttons if table is too wide.
  th,
  td {
    white-space: nowrap;
  }
  tr:hover td:last-child {
    position: sticky;
    right: 0;
  } */
`

const PagingItem = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  &.align-right {
    text-align: right;
  }
`

class TableWithLocalPagination extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showSettingsModal: false,
      headers: props.headers,
      // eslint-disable-next-line react/no-unused-state
      search: '',
      allData: [],
    }
    this.onSearch = this.onSearch.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.onSaveSettings = this.onSaveSettings.bind(this)
    this.onChangePageSize = this.onChangePageSize.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.searchTimeout = null
  }

  createData = (data, currentPage, pageSize) => {
    if (data.length > 0) {
      const tempData = data.slice(currentPage, pageSize)
      this.setState({ allData: tempData })
    }
  }

  componentWillReceiveProps = nextProps => {
    const { currentPage, pageSize, data } = nextProps
    if (currentPage !== this.props.currentPage || pageSize !== this.props.pageSize) {
      this.setState({
        allData: this.createData(this.props.data, this.props.currentPage, this.props.pageSize),
      })
    }
    if (!shallowEqual(data !== this.props.data)) {
      this.setState({
        allData: this.createData(this.props.data, this.props.currentPage, this.props.pageSize),
      })
    }
  }

  onSaveSettings(headers) {
    const { showSettingsModal } = this.state
    this.setState({
      showSettingsModal: !showSettingsModal,
      headers,
    })
  }

  onSearch(value) {
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => this.props.onSearch({ target: { value } }), 500)
  }

  toggleModal() {
    const { showSettingsModal } = this.state
    this.setState({ showSettingsModal: !showSettingsModal })
  }

  onChangePageSize(size) {
    const { currentPage, total } = this.props
    if (this.props.onChangePageSize) {
      this.props.onChangePageSize(size)
    }
    if ((Number(currentPage) - 1) * Number(size) > Number(total)) {
      if (this.props.onChangePage) {
        this.props.onChangePage(1)
      }
    }
  }

  onChangePage(page) {
    if (this.props.onChangePage) {
      this.props.onChangePage(page)
    }
  }

  render() {
    const {
      classes,
      hideTableSetting,
      hideTableTop,
      hideTablePaging,
      hideTableSearch,
      leftButton,
      filterComponents,
      data,
      disableReArrange,
      className,
      wrapperClassName,
      onSort,
      onChangePageSize,
      onChangePage,
      isShowRequire,
      currentPage,
      total,
      totalSelected,
      pageSize,
      searchPlaceholder,
      noDataMessage,
      itemName,
      exportDataUrl,
      exportDataPath,
      showExportData,
      exportFileName,
      ExpandedRowRender,
      expandedRowColspan,
      ...rest
    } = this.props
    // eslint-disable-next-line no-unused-vars
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { showSettingsModal, headers, allData } = this.state

    const colSpan = headers.length + 1

    return (
      <div className={wrapperClassName}>
        {!hideTableTop && (
          <div className={classes['top-table']}>
            <div className="header-button">{leftButton}</div>
            <div className={classes['search-box']}>
              <div className={classes.filter}>{filterComponents}</div>
              {!hideTableSearch && (
                <TextInput
                  className={classes['search-box-item']}
                  placeholder={searchPlaceholder}
                  onChange={e => this.onSearch(e.target.value)}
                  icon={<i className="material-icons">search</i>}
                />
              )}
              {!hideTableSetting && (
                <IconButton
                  className={classes['table-config']}
                  icon={<Settings />}
                  onClick={this.toggleModal}
                  aria-label="Settings"
                />
              )}
            </div>
          </div>
        )}
        <TableWrap>
          <table className={cn(classes.table, className)} {...rest}>
            <TableHeader
              headers={headers}
              onSortChange={onSort}
              isShowRequire={isShowRequire}
              ExpandedRowRender={ExpandedRowRender}
            />
            {/* {!_.isEmpty(data) && (
              <tbody>
                {data.map((row, i) => [
                  <TableRow key={i} data={row} rowKey={i} headers={headers} />,
                  row.bottomRow ? <tr><td colspan={10} className={classes.bottomRow}>{row.bottomRow}</td></tr> : null,
                ])}
              </tbody>
            )} */}
            <tbody>
              {_.map(
                data.slice(
                  (Number(currentPage) - 1) * Number(pageSize),
                  (Number(currentPage) - 1) * Number(pageSize) + Number(pageSize)
                ),
                (row, i) => (
                  <React.Fragment>
                    <TableRow
                      // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                      key={i}
                      data={row}
                      rowKey={i}
                      headers={headers}
                      ExpandedRowRender={ExpandedRowRender}
                      expandedRowColspan={expandedRowColspan || colSpan}
                    />
                    {row.bottomRow && (
                      <tr>
                        <td colSpan={10} className={classes.bottomRow}>
                          {row.bottomRow}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              )}
            </tbody>
          </table>
        </TableWrap>
        {_.isEmpty(data) && (
          <div className={classes.noData}>
            <Text component="h2">{noDataMessage}</Text>
          </div>
        )}
        <div className={classes['paging-wrapper']}>
          {!hideTablePaging && (
            <React.Fragment>
              <PagingItem>
                <PagingSetting
                  exportFileName={exportFileName}
                  showExportData={showExportData}
                  exportDataUrl={exportDataUrl}
                  exportDataPath={exportDataPath}
                  headers={headers}
                  onChangePageSize={this.onChangePageSize}
                  currentPage={currentPage}
                  total={total}
                  itemName={itemName}
                  options={[5, 10, 25, 50]}
                  itemPerPage={pageSize}
                  totalSelected={totalSelected}
                />
              </PagingItem>
              {total > 0 && (
                <Pagination
                  numPage={Math.ceil(total / pageSize)}
                  activePage={currentPage}
                  setPage={this.onChangePage}
                />
              )}
            </React.Fragment>
          )}
          {!hideTableSetting && (
            <PagingItem>
              <TableSettingModal
                disableReArrange={disableReArrange}
                onSave={this.onSaveSettings}
                headers={headers}
                toggleModal={this.toggleModal}
                isOpenModal={showSettingsModal}
              />
            </PagingItem>
          )}
          {showExportData && (
            // biome-ignore lint/complexity/noUselessFragments: TODO
            <React.Fragment>
              {total > 0 && [
                // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                <PagingItem className="align-right">
                  <ExportTableData
                    exportFileName={exportFileName}
                    exportDataUrl={exportDataUrl}
                    exportDataPath={exportDataPath}
                    headers={headers}
                  />
                </PagingItem>,
              ]}
            </React.Fragment>
          )}
        </div>
      </div>
    )
  }
}

TableWithLocalPagination.defaultProps = {
  className: '',
  data: [],
  disableReArrange: false,
  filterComponents: null,
  headers: [],
  hideTableSetting: false,
  hideTablePaging: false,
  hideTableSearch: false,
  hideTableTop: false,
  leftButton: null,
  showExportData: false,
  onSort: () => {},
  pageSize: 5,
  searchPlaceholder: 'Type to search',
  noDataMessage: 'No Data',
  itemName: 'items',
  isShowRequire: false,
}

export default withStyles(styles)(TableWithLocalPagination)
